import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Http} from '@angular/http';
import {User} from '../../../models/user';
import {AuthControllerService} from '../../../services/auth-controller/auth-controller.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    providers: [AuthControllerService]
})
export class RegisterPage implements OnInit {

    user: User = new User();
    passwordRepeat: string;
    error: any;
    errorMessage;
    showPasswordDoNotEqualMessage: boolean = false;
    errors;

    constructor(private authService: AuthControllerService,
                private router: Router,
                private http: Http) {
    }

    ngOnInit() {
    }

    updateErrorMessage(){
        this.showPasswordDoNotEqualMessage = this.passwordRepeat
            && this.passwordRepeat.length > 0
            && this.passwordRepeat !== this.user.password
    }

    register() {
        if(this.showPasswordDoNotEqualMessage){
            return
        }
        return this.authService.register(this.user).subscribe(
            (resp) => {
                AuthControllerService.showRegisteredMessage = true
                this.router.navigate(['/login/']);
            },
            (error) => {
                const errorBody = JSON.parse(error._body);
                if(errorBody.status === "BadPassword"){
                    delete this.error
                    this.errors = errorBody.reasons
                }else{
                    this.errors = []
                    this.error = errorBody.message
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/register/register.component.ts